module.exports = __webpack_public_path__ + "static/media/preview.7b30759c.svg";